module.exports = __webpack_public_path__ + "media/images/icons/icon-pending-large-aac84563882fd34ecfc75ab36ec3b457.svg";